import script from "./InvitedTeamUser.vue?vue&type=script&setup=true&lang=js"
export * from "./InvitedTeamUser.vue?vue&type=script&setup=true&lang=js"

import "./InvitedTeamUser.vue?vue&type=style&index=0&id=0b8f4e1d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b8f4e1d"]])

export default __exports__